var map = {
	"./en/manageTicket.json": 61814,
	"./es/manageTicket.json": 86893,
	"./fr/manageTicket.json": 28616,
	"./it/manageTicket.json": 79843,
	"./pt-BR/manageTicket.json": 68948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17453;